import {lazy, filter} from './lang.js';
import {doc} from './documentation.js';

/**
 * Returns the density at that point of time, going back
 * windowSize-many steps.
 *
 * How could this be used? 
 */
doc(
    "density",
    {
        "windowSize": "The number of steps that we look back from to calculate the density"
    },
    "Calculates the number of triggers received in the last windowSize-many steps"
);
export const density = (windowSize) => {
    let buffer = [];
    let lastStepNumber = undefined;
    return (stepData, stepNumber, time) => {
        for (let i=lastStepNumber + 2; i < stepNumber; i+=2) {
            buffer.shift();
        }

        let _window = lazy(windowSize, stepData, stepNumber, time);
        if (stepNumber !== lastStepNumber) {
            while (buffer.length > _window) {
                buffer.shift();
            }
        }
        let d = buffer.filter(x => x).map(x => x.chop)
            .reduce(
                (a,b) => a + b, 0);
        buffer.push(stepData);
        lastStepNumber = stepNumber;
        return d;
    };
};

